query AnalyticsUsersByLanguage($filter: AnalyticsUsersFilterInput!) {
  analyticsUsers(filter: $filter) {
    usersByLanguage {
      language
      users
    }
  }
}
